<form [formGroup]="addModuleForm">
    <error-message [errors]="errors"></error-message>
    <div class="container">

        <div class="row form-group">
            <div class="col-md-5">
                <label class="control-label text-primary">Modules</label>
                <div>
                    <select class="js-example-basic-single form-select" name="moduleId" formControlName="moduleId" placeholder="Select a module">
                        <option *ngFor="let m of modules" [value]="m.id">{{ m.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <label class="control-label text-primary">
                    Is Mandatory
                </label>
                <input type="checkbox" id="isMandatory" name="isMandatory" class="form-control" formControlName="isMandatory" appToggle />
                <span class="text-muted" *ngIf="addModuleForm.value.isMandatory">This module is automatically added to a user audit</span>
                <span class="text-muted" *ngIf="!addModuleForm.value.isMandatory">A user can optionally add this module to a user audit</span>
            </div>
            <div class="col-md-3">
                <label class="control-label text-primary">
                    Is Singular
                </label>
                <input type="checkbox" id="isSingular" name="isSingular" class="form-control" formControlName="isSingular" appToggle />
                <span class="text-muted" *ngIf="addModuleForm.value.isSingular">Only one instance of a module can be added to a user audit</span>
                <span class="text-muted" *ngIf="!addModuleForm.value.isSingular">A user can add multiple instances of this module to a user audit</span>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-12 text-right">
                <button type="button" class="btn btn-success" (click)="addModuleToAuditTemplate();" [disabled]="submitAttempt||!addModuleForm.valid">Add Module to Audit Template</button>
            </div>
        </div>

    </div>
</form>
